import styled from "@emotion/styled";
import { surface, nav } from "./semantic/colors";
import { zIndex } from "./primitives/layout";
import { breakpointValues as bpValues, breakpointHeightValues } from "./primitives/layout";
import { duration } from "./semantic/animation";
import { layout } from "./semantic/layout";
import { slideOpenMenu, slideCloseMenu } from "./animations";

export const gridLines = {
  globalPageLeft: "GlobalPageLeft",
  globalPageRight: "GlobalPageRight",
  globalPageTop: "GlobalPageTop",
  globalPageBottom: "GlobalPageBottom",
  infoBannerBottom: "InfoBannerBottom",
  globalControlsLeft: "GlobalControlsLeft",
  globalNavigationBarLeft: "GlobalNavigationBarLeft",
  globalNavigationBarRight: "GlobalNavigationBarRight",
  globalMainContentAreaLeft: "GlobalMainContentAreaLeft",
  globalMainContentAreaRight: "GlobalMainContentAreaRight",
  globalFooterTop: "GlobalFooterTop",
  globalFooterBottom: "GlobalFooterBottom",
};

export const gridAreas = {
  infoBanner: "infoBanner",
  navigationBar: "navigationBar",
  content: "content",
  controls: "ControlsArea",
  footer: "FooterArea",
};

/*
In the following grid-template specifications, the use of minmax()
helps constrain the size of the grid tracks. If fr units are used by
themselves, e.g., 3fr 1fr, then the tracks will be allowed to dynamically
change size according to the size of content inside of them.
Using minmax(0, __) prevents this automatic resizing from happening.
*/

export const GlobalContainer = styled.div`
  display: grid;
  width: 100%;
  height: 100vh;
    grid-template-areas:
    "navigationBar content";
  grid-template-rows: minmax(0, 1fr);
  grid-template-columns: ${layout.navBarWidth} minmax(0, 1fr);
  background-color: ${surface.raised};
`;

export const NavigationBarContainer = styled.div`
  grid-area: ${gridAreas.navigationBar};
  background-color: ${nav.background};
  display: flex;
  flex-direction: column;
  padding: 0px;
  overflow-x: hidden;
  overflow-y: auto;
  box-sizing: border-box;
  z-index: ${zIndex.navigation};

  &.expanded {
    animation-name: ${slideOpenMenu};
    animation-duration: ${duration.base};
    animation-timing-function: linear;
    animation-iteration-count: 1;
    animation-fill-mode: forwards;

    overflow-y: auto;
  }

  &.closed {
    animation-name: ${slideCloseMenu};
    animation-duration: ${duration.base};
    animation-timing-function: linear;
    animation-iteration-count: 1;
    animation-fill-mode: forwards;
  }

  &.contentPage {
    background: none;
  }

  &.contentPage.expanded {
    background-color: ${nav.background};
  }
`;

export const MainContentContainer = styled.div`
  grid-area: ${gridAreas.content};
  padding: 0px;
  box-sizing: border-box;
`;

export const breakPoints = {
  medium: `screen and (max-width: ${bpValues.lg}px),
            screen and (max-height: ${breakpointHeightValues.lg}px)`,
  mediumSmall: `screen and (max-width: ${bpValues.md}px),
            screen and (max-height: ${breakpointHeightValues.md}px)`,
  small: `screen and (max-width: ${bpValues.sm}px),
            screen and (max-height: ${breakpointHeightValues.sm}px)`,
};
